export default __webpack_public_path__ + "static/media/scratch3.6b3241bc.mp3";